export default "/etc.clientlibs/pg/clientlibs/clientlib-site/resources/images/0993ba5080a89a6727f29d95d05ea124.svg";